export default __webpack_public_path__ + "static/media/Montserrat-ExtraBold.0eac3d0f.ttf";